import { createFileRoute } from '@tanstack/react-router';
import { Layout, theme } from 'antd';
import Header from '@/components/layout/Header';
import DarkModeToggle from '@/components/ui/DarkModeToggle';
import LanguageSwitcher from '@/components/ui/LanguageSwitcher';
import {
  HeroSection,
  StatsSection,
  FeaturesSection,
  HowItWorksSection,
  UseCasesSection,
  TestimonialsSection,
  EnterpriseSection,
  CTASection,
  LandingFooter
} from '@/components/landing';

const { Content } = Layout;

// Define the route for the landing page
export const Route = createFileRoute('/')({
  component: RouteComponent
});

function RouteComponent() {
  const { token } = theme.useToken();

  return (
    <Layout style={{ minHeight: '100vh', background: token.colorBgLayout }}>
      <Header transparent showDarkModeSwitch={false} />

      <Content style={{ padding: '0' }}>
        <HeroSection />
        <StatsSection />
        <FeaturesSection />
        <HowItWorksSection />
        <UseCasesSection />
        <TestimonialsSection />
        <EnterpriseSection />
        <CTASection />
      </Content>

      <LandingFooter />

      <DarkModeToggle />
      <LanguageSwitcher />
    </Layout>
  );
}
